import cx from "classnames";
import React, { useEffect, useState } from "react";
import moment from "moment";

// A simple filter which filters on provided text
export const DateFilter = (props) => {
    const [val, setVal] = useState("");

    const convert = (val) => {
        const mom = moment(val, "DD-MM-YYYY");
        return mom.isValid() ? mom : "";
    };

    useEffect(() => {
        if (val !== "") {
            const filter = convert(val);
            if (filter !== "") {
                props.setFilter(props.columnIdentifier, filter.format("YYYY-MM-DD"));
            }
        } else {
            props.setFilter(props.columnIdentifier, "");
        }
    }, [val]);

    return (
        <input
            key={props.columnIdentifier}
            className={cx("text-filter", props.className)}
            type={"text"}
            placeholder={props.placeholder}
            onChange={(e) => setVal(e.target.value)}
            value={val}
            maxLength={props.maxLength || ""}
        />
    );
};
